/*
 * Initialize 
 * Initialize various libraries within the framework
 * MIT License
 */
(function($) {

    AOS.init();

    //dynamic add class for homepage 
    $('.home .calendar').addClass('container')

   

})(jQuery);